'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import styled from 'styled-components';
import partial from 'transmute/partial';
import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import Branding from 'MeetingsBase/models/Branding';
import { getPrimaryButtonStyle, getPrimaryButtonHoverStyle, getSecondaryButtonStyle, getSecondaryButtonHoverStyle } from 'MeetingsLib/utils/color';
import PreviewContext from 'MeetingsLib/utils/PreviewContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
var BUTTON_WIDTH = '102px';
var FooterContainer = styled(UIBox).withConfig({
  displayName: "StepButtonsFooter__FooterContainer",
  componentId: "sc-1xiostk-0"
})(["flex-grow:0;padding-left:40px;padding-right:40px;", ""], function (_ref) {
  var compact = _ref.compact;
  return compact ? "\n    background: " + GYPSUM + ";\n    border-top: solid 1px " + BATTLESHIP + ";\n    padding-top: 16px;\n    padding-bottom: 18px;\n  " : "padding-top: 28px;\n         padding-bottom: 24px;";
});
export default createReactClass({
  displayName: "StepButtonsFooter",
  mixins: [ComponentWithPartials],
  propTypes: {
    submittingMeeting: PropTypes.bool,
    goToPreviousStep: PropTypes.func,
    goToNextStep: PropTypes.func,
    isLastStep: PropTypes.bool,
    canProceed: PropTypes.bool,
    tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    offline: PropTypes.bool,
    compact: PropTypes.bool,
    branding: PropTypes.instanceOf(Branding).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      forwardButtonHover: false,
      backButtonHover: false
    };
  },
  onMouseEnter: function onMouseEnter(newState) {
    this.setState(newState);
  },
  onMouseLeave: function onMouseLeave(newState) {
    this.setState(newState);
  },
  getForwardButtonKey: function getForwardButtonKey() {
    var lastStepKey = this.props.offline ? 'buttons.confirm.offline' : 'buttons.confirm.online';
    return this.props.isLastStep ? lastStepKey : 'buttons.next';
  },
  getForwardButtonVisibility: function getForwardButtonVisibility() {
    return this.props.goToNextStep ? 'visible' : 'hidden';
  },
  getProceedFunction: function getProceedFunction() {
    var _this$props = this.props,
        goToNextStep = _this$props.goToNextStep,
        goToPreviousStep = _this$props.goToPreviousStep;
    return goToNextStep ? this.partial(goToNextStep, goToPreviousStep) : null;
  },
  renderBackButton: function renderBackButton() {
    var _this = this;

    var _this$props2 = this.props,
        goToPreviousStep = _this$props2.goToPreviousStep,
        primaryColor = _this$props2.branding.primaryColor,
        compact = _this$props2.compact;

    if (!goToPreviousStep) {
      return null;
    }

    var brandingStyle = this.state.backButtonHover ? getSecondaryButtonHoverStyle(primaryColor) : getSecondaryButtonStyle(primaryColor);
    return /*#__PURE__*/_jsx(PreviewContext.Consumer, {
      children: function children(isPreview) {
        return /*#__PURE__*/_jsxs(UIButton, {
          style: Object.assign({
            minWidth: BUTTON_WIDTH,
            marginLeft: 0
          }, brandingStyle),
          onClick: isPreview ? null : goToPreviousStep,
          use: "secondary",
          size: compact ? 'small' : 'default',
          responsive: false,
          "data-selenium-test": "back-button",
          onMouseEnter: partial(_this.onMouseEnter, {
            backButtonHover: true
          }),
          onMouseLeave: partial(_this.onMouseLeave, {
            backButtonHover: false
          }),
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "left"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "buttons.back"
          })]
        });
      }
    });
  },
  renderForwardButton: function renderForwardButton() {
    var _this2 = this;

    var _this$props3 = this.props,
        submittingMeeting = _this$props3.submittingMeeting,
        canProceed = _this$props3.canProceed,
        tooltipTitle = _this$props3.tooltipTitle,
        primaryColor = _this$props3.branding.primaryColor,
        compact = _this$props3.compact;
    var visibility = this.getForwardButtonVisibility();
    var messageKey = this.getForwardButtonKey();
    var goToNextStep = this.getProceedFunction();
    var brandingStyle = this.state.forwardButtonHover ? getPrimaryButtonHoverStyle(primaryColor) : getPrimaryButtonStyle(primaryColor);

    var forwardButton = /*#__PURE__*/_jsx(PreviewContext.Consumer, {
      children: function children(isPreview) {
        return /*#__PURE__*/_jsx(UILoadingButton, {
          style: Object.assign({
            minWidth: BUTTON_WIDTH,
            visibility: visibility
          }, brandingStyle),
          loading: submittingMeeting || false,
          onClick: isPreview ? null : goToNextStep,
          use: "primary",
          size: compact ? 'small' : 'medium',
          responsive: false,
          disabled: !canProceed,
          "data-selenium-test": "forward-button",
          onMouseEnter: partial(_this2.onMouseEnter, {
            forwardButtonHover: true
          }),
          onMouseLeave: partial(_this2.onMouseLeave, {
            forwardButtonHover: false
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: messageKey
          })
        });
      }
    });

    if (tooltipTitle) {
      return /*#__PURE__*/_jsx(UITooltip, {
        title: tooltipTitle,
        disabled: canProceed,
        children: forwardButton
      });
    }

    return forwardButton;
  },
  render: function render() {
    var compact = this.props.compact;
    return /*#__PURE__*/_jsx(FooterContainer, {
      className: "width-100",
      compact: compact,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "row-reverse",
        align: "end",
        justify: "between",
        children: [this.renderForwardButton(), this.renderBackButton()]
      })
    });
  }
});